import { ContentfulClient } from '@jbhi-fi/apis/src/contentful/ContentfulClient';
import { ContentfulThemeApiClient } from '@jbhi-fi/apis/src/contentfulThemeApi/ContentfulThemeApiClient';
import { serviceHelper } from '../../config/service-helper';

export class ContentfulApiClient extends ContentfulClient {
  constructor() {
    super({
      accessToken: serviceHelper.contentfulToken,
      environment: serviceHelper.contentfulEnvironment,
      space: serviceHelper.contentfulSpaceId,
    });
  }
}

export class ContentfulPreviewThemeApiClient extends ContentfulThemeApiClient {
  constructor() {
    super({
      themeApiBaseUrl: serviceHelper.themeApisUrl,
    });
  }
}
